import * as vp from 'vopay';

import { createContext } from 'react';

export type PartnerAccountContext = {
  balances: vp.AccountBalance[];
  details: vp.AccountDetailsMap;
  /** Whether the account request behind `details` has answered — see AccountsContainer. */
  hasAccountsSettled: boolean;
  hasPendingAccountCreationData: boolean;
  permissions: vp.AccountPermissionsMap;
  setHasPendingAccountCreationData: (hasData: boolean) => void;
  setShouldFetchData: (shouldFetch: boolean) => void;
};

const AccountsContext = createContext<PartnerAccountContext>({
  balances: [],
  details: {},
  hasAccountsSettled: false,
  hasPendingAccountCreationData: false,
  permissions: {},
  setHasPendingAccountCreationData: () => {},
  setShouldFetchData: () => {},
});

export default AccountsContext;
